type FormInputFieldProps = {
    title: string
    children: React.ReactNode
}

const FormField = ({title, children}: FormInputFieldProps) => {
    return (
        <div className="grid grid-cols-10">
            <div className="col-span-3 flex pt-3 text-2xl">{title}</div>
            <div className="col-span-7 flex">{children}</div>
        </div>
    )
}

export default FormField
